export default "__VITE_ASSET__DpPs5eqh__"